import '@css/main.css';
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import axios from "axios";

Alpine.plugin(persist);

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {

  /**
   * Global state store for the shortlist
   * with its API.
   */
  Alpine.store('bgShortlist', {
    list: Alpine.$persist([]),

    add(id) {
      if (this.list.includes(id)) return;

      this.list.push(id);
    },

    addAndRedirect(id) {
      if (!this.list.includes(id)) {
        this.list.push(id);
      }

      window.location.href = '/job-shortlist';
    },

    remove(id) {
      const index = this.list.indexOf(id);
      if (index > -1) {
        this.list.splice(index, 1);
      }
    },

    clear() {
      this.list = [];
    }
  })

  /**
   * The Shortlist application.
   */
  Alpine.data('bgShortlistList', () => ({
    init() {
      if (Alpine.store('bgShortlist').list.length > 0) {
        const ids = {ids: Alpine.store('bgShortlist').list};

        axios.get('/jobs.json', { params: ids })
          .then(response => {
            this.data = response.data.data;
          })
          .catch(() => {
            this.data = false;
          });
      }
    },

    data: Alpine.reactive([])
  }));

  /**
   * The Shortlist "clear it all now" shortcut.
   */
  Alpine.data('clearsLocalStorage', () => ({
    init() {
      Alpine.store('bgShortlist').clear();
    }
  }));

  Alpine.data('bgJumbotron', maxBanners => ({
    active: 0,
    timeout: 6000,
    hold: false,
    init() {
      this.loop()
      this.$el.addEventListener('mouseenter', () => this.hold = true)
      this.$el.addEventListener('mouseleave', () => this.hold = false)
    },
    loop() {
      setInterval(() => this.intervalHandler(), this.timeout)
    },
    intervalHandler() {
      if (this.hold) return
      this.next()
    },
    next() {
      this.active = (this.active + 1) % maxBanners
    },
    previous() {
      this.active = this.active === 0 ? maxBanners - 1 : this.active - 1
    }
  }))

})

Alpine.start();

var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    document.getElementById("bannerPopUp").style.top = "-11rem";
  } else {
    document.getElementById("bannerPopUp").style.top = "0";
  }
  prevScrollpos = currentScrollPos;
}
